import styled from 'styled-components';

import { ButtonBoxPrimary } from '~/src/ui/button';
import { Footnote } from '~/src/ui/typography';

export const FormBox = styled.form`
  ${Footnote} {
    margin-top: 8px;
  }

  ${ButtonBoxPrimary} {
    margin-top: 20px;

    @media (max-width: 639px) {
      width: 100%;
    }
  }
`;

export const FormGroup = styled.div`
  display: grid;
  grid-gap: 16px;

  @media (min-width: 1200px) {
    grid-gap: 8px;
    grid-template-columns: 1fr 1fr;
  }
`;

export const FormField = styled.div<{ $isBigGap?: boolean, $isSmallGap?: boolean }>`
  margin-top: ${({ $isSmallGap }): string => ($isSmallGap ? '8px!important' : '16px')};

  &:first-child {
    margin-top: 0;
  }

  @media (min-width: 1200px) {
    margin-top: ${({ $isBigGap }): string => ($isBigGap ? '20px' : '16px')};

    &:first-child {
      margin-top: 0;
    }
  }
`;

FormBox.displayName = 'FormBox';
FormField.displayName = 'FormField';
